<template>
  <form @submit.prevent="submit" class="attachment-form uk-form-stacked">
    <checkbox
      :disabled="!isEditable"
      :errors="form.errors.remote"
      :label="$t('hints.remote')"
      ref="source"
      v-if="allowSelectSource"
      v-model="form.model.remote"
    />
    <text-input
      :disabled="!isEditable"
      :errors="form.errors.url"
      :label="$t('fields.url')"
      @change="autoSetType"
      v-if="form.model.remote"
      v-model="form.model.url"
    />
    <text-input
      :disabled="!isEditable"
      :errors="form.errors.thumbImageUrl"
      :label="$t('fields.thumbImageUrl')"
      @change="autoSetType"
      v-if="form.model.remote"
      v-model="form.model.thumbImageUrl"
    />
    <file-input
      :disabled="!isEditable"
      :errors="form.errors.file"
      :label="$t('fields.file')"
      @change="autoSetType"
      v-else
      v-model="form.model.file"
    />
    <radio-group-input
      :collection="availableTypes"
      :disabled="!isEditable"
      :errors="form.errors.type"
      :label="$t('fields.type')"
      v-if="form.model.remote && allowSelectType"
      v-model="form.model.type"
    />
    <text-input
      :disabled="!isEditable"
      :errors="form.errors.name"
      :label="$t('fields.name')"
      :placeholder="model && model.fileName"
      @change="autoSetType"
      ref="name"
      v-model="form.model.name"
    />

    <submit-button :disabled="!isSubmittable" type="primary" />
    <cancel-button />
  </form>
</template>

<script>
import camelCase from 'lodash/camelCase';
import includes from 'lodash/includes';
import Form from '@/mixins/LegacyForm';
import FileInput from '@/components/FileInput';
import RadioGroupInput from '@/components/RadioGroupInput';

const TYPES = {
  IMAGE: ['jpg', 'jpeg', 'jpe', 'png', 'gif', 'svg'],
  VIDEO: ['webm', 'mp4'],
  DOCUMENT: ['pdf', 'rtf'],
};

export default {
  name: 'attachment-form',
  components: {
    FileInput,
    RadioGroupInput,
  },
  mixins: [
    Form({
      name: true,
      type: { required: true },
      remote: { default: false },
      file: true,
      url: true,
      thumbImageUrl: true,
    }),
  ],
  mounted() {
    if (this.$refs.source) {
      this.$refs.source.focus();
    } else {
      this.$refs.name.focus();
    }
  },
  data() {
    return {
      detectedType: null,
    };
  },
  props: {
    allowSelectSource: {
      type: Boolean,
      default: true,
    },
    allowSelectType: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    availableSources() {
      return [
        {
          label: this.$t('attachmentSources.local'),
          value: false,
        },
        {
          label: this.$t('attachmentSources.remote'),
          value: true,
        },
      ];
    },
    availableTypes() {
      return Object.keys(TYPES).map(type => (
        {
          label: this.$t(`attachmentTypes.${camelCase(type)}`),
          value: type,
        }
      ));
    },
    autoDetectType() {
      const model = this.form.model;
      return !model.type || model.type === this.detectedType;
    },
  },
  methods: {
    autoSetType() {
      if (!this.autoDetectType) return;
      const model = this.form.model;
      let path;
      if (model.remote) {
        path = model.url;
      } else {
        path = model.file && model.file.name;
      }
      if (!path) return;
      const extname = path.substr(path.lastIndexOf('.') + 1).toLowerCase();
      let detectedType;
      Object.keys(TYPES).forEach((type) => {
        if (includes(TYPES[type], extname)) {
          detectedType = type;
        }
      });
      if (detectedType) {
        this.detectedType = detectedType;
        model.type = detectedType;
      }
    },
  },
  i18n: {
    messages: {
      de: {
        fields: {
          name: 'Name (optional)',
          thumbImageUrl: 'Vorschau URL (optional)',
        },
        hints: {
          remote: 'Datei von externem Server verlinken',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// AttachmentForm.vue?f97d93b0